import { Component } from 'react';
import { connect } from "react-redux";
import { Route, HashRouter, Link } from 'react-router-dom';
import { getLangList } from "@/lib/i18n";
import { Layout } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { getStorage, registerSetSessionStroageEvent } from "@/lib/webStorage";
import LostAndFound from '@/containers/lostAndFound';
import Attendance from '@/containers/attendance';
import Rent from '@@/src/containers/rent';
import MenuBar from '@components/menuBar';
import ProfileToolbar from '@/components/profileToolbar';
import BuyRecord from '@/containers/buyRecord';
import Announcement from '@/containers/announcement';
import RollCall from '@/containers/rollCall';
import LeaveSystem from '@/containers/leaveSystem';
import Bus from '@/containers/bus';
import Sale from '@/containers/sale';
import Login from '@/containers/login';
import Loading from '@/components/loading';
import RentOutField from '@containers/rentOutField';
import Schedule from '@/containers/schedule';
import Home from '@/containers/home';
import ClassManagement from '@/containers/organization/classManagement';
import PermissionManagement from '@/containers/organization/permissionManagement';
import StudentManagement from '@/containers/humanResourceManagement/studentManagement';
import TeacherManagement from '@/containers/humanResourceManagement/teacherManagement';
import SubjectManagement from '@/containers/organization/subjectManagement';
import SemesterManagement from '@/containers/organization/semesterManagement';
import Transcript from '@/containers/transcript';
import ArchivedTranscript from '@/containers/archived/archivedTranscript';
import './index.less';

const { Header, Content, Footer, Sider } = Layout;

interface props {
  dispatch: any;
  login: any;
  loading: any;
}

interface state {
  collapsed: boolean;
}

const event = registerSetSessionStroageEvent('currentMenuIndex');
class LayoutPage extends Component<props, state> {
  state = {
    collapsed: false,
  };
  layOutPageT: any = getLangList("layOutPage");

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  clickHomeButton = () => {
    event.newValue = '0';
    window.dispatchEvent(event);
  }

  render() {
    const { loading } = this.props;
    const { collapsed } = this.state;
    const { spinStatus } = loading;
    const username = getStorage("username");
    const token = getStorage("token");
    const islogin = !!token && !!username;

    return (
      <HashRouter>
        {spinStatus ? <Loading /> : ""}
        <Layout>
          <Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
          >
            <Link to="/home" onClick={this.clickHomeButton}>
              <div className="logo" />
            </Link>

            {islogin && <MenuBar />}
          </Sider>
          <Layout>
            <Header className="header">
              <div className="header-container">
                <span className="trigger" onClick={this.toggle}>
                  {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </span>
                {islogin && <ProfileToolbar />}
              </div>
            </Header>

            <Content className="content">
              <div className="content-container">
                <Route exact path="/" component={Login} />
                <Route exact path="/home" component={Home} />
                <Route exact path="/lostAndFound" component={LostAndFound} />
                <Route exact path="/attendance" component={Attendance} />
                <Route exact path="/rent" component={Rent} />
                <Route exact path="/buyRecord" component={BuyRecord} />
                <Route exact path="/announcement" component={Announcement} />
                <Route exact path="/rollCall" component={RollCall} />
                <Route exact path="/leaveSystem" component={LeaveSystem} />
                <Route exact path="/bus" component={Bus} />
                <Route exact path="/sale" component={Sale} />
                <Route exact path="/rentOutField" component={RentOutField} />
                <Route exact path="/schedule" component={Schedule} />
                <Route exact path="/classManagement" component={ClassManagement} />
                <Route exact path="/permissionManagement" component={PermissionManagement} />
                <Route exact path="/studentManagement" component={StudentManagement} />
                <Route exact path="/teacherManagement" component={TeacherManagement} />
                <Route exact path="/semesterManagement" component={SemesterManagement} />
                <Route exact path="/subjectManagement" component={SubjectManagement} />
                <Route exact path="/transcript" component={Transcript} />
                <Route exact path="/archivedTranscript" component={ArchivedTranscript} />
              </div>
            </Content>

            <Footer className="footer">
              {this.layOutPageT.FOOTER_TEXT}
            </Footer>
          </Layout>
        </Layout >
      </HashRouter >
    );
  }
}

function mapStateToProps(state: any) {
  const { login, loading } = state;
  return { login, loading };
}

export default connect(mapStateToProps)(LayoutPage);